export const MOODS = [
  {
    id: 1,
    label: 'แย่มาก',
    color: '#8B1E1E',
    face: 'angry',
    hint: 'ยังโมโหอยู่ ลองเล่นต่อเพื่อระบายอีกได้',
    hintClass: 'mood-hint--bad',
  },
  {
    id: 2,
    label: 'ยังไม่ดี',
    color: '#E07A2F',
    face: 'sad',
    hint: 'เริ่มดีขึ้นนิดหน่อย เล่นต่ออีกหน่อยจะโล่งกว่านี้',
    hintClass: 'mood-hint--bad',
  },
  {
    id: 3,
    label: 'เฉยๆ',
    color: '#E6C84A',
    face: 'neutral',
    hint: 'รู้สึกกลางๆ เล่นต่อหรือออกก็ได้',
    hintClass: '',
  },
  {
    id: 4,
    label: 'ดีขึ้น',
    color: '#8BC34A',
    face: 'smile',
    hint: 'โล่งขึ้นแล้ว พร้อมออกจากเกมได้',
    hintClass: 'mood-hint--good',
  },
  {
    id: 5,
    label: 'ดีมาก',
    color: '#2E7D32',
    face: 'happy',
    hint: 'ระบายได้ดีมาก พร้อมกลับไปทำอย่างอื่นต่อได้เลย',
    hintClass: 'mood-hint--good',
  },
];
